import $ from 'jquery';
import throttle from 'lodash-es/throttle';

class StickyToolbar {
	constructor() {
		this.window = $( window );
		this.body = $( 'body' );
		this.loopDivider = $( '.product-loop-divider' ).last();
		this.toolbarOffset = this.getToolbarOffset();
		this.stickyToolbar = '';

		// Elements to clone and append
		this.elementArr = [
			$( '.woocommerce-breadcrumb' ).last(),
			$( '.product-loop-heading' ).last(),
			$( '.woocommerce-result-count' ),
			$( '.woocommerce-ordering' ),
		];

		this.appendToolbar();
		this.event();
	}

	event() {
		this.window.on( 'scroll', throttle( () => ( this.toolbarOffset <= this.window.scrollTop() ? this.showSticky() : this.hideSticky() ), 100 ) );
	}

	showSticky() {
		if ( ! this.stickyToolbar.hasClass( 'toolbar-active' ) ) {
			this.stickyToolbar.addClass( 'toolbar-active' );
		}
	}

	hideSticky() {
		if ( this.stickyToolbar.hasClass( 'toolbar-active' ) ) {
			this.stickyToolbar.removeClass( 'toolbar-active' );
		}
	}

	getToolbarOffset() {
		return this.loopDivider.offset().top;
	}

	appendToolbar() {
		this.body.append(
			`<div class="sticky-toolbar">
				<div class="sticky-toolbar-inner">
				</div>
			</div>`
		);

		// Add elements to the toolbar
		this.appendElements();

		// Cache the element
		this.stickyToolbar = $( '.sticky-toolbar' );
	}

	appendElements() {
		this.elementArr.map( element => element.clone().appendTo( '.sticky-toolbar-inner' ) );
	}
}

export default StickyToolbar;
